import { useState } from 'react';
import { useRef } from 'react';
import { useCallback } from 'react';
import {
  PeoplePageDerivedSectionSourcesUpdaterProps,
  PeoplePageDerivedSectionSourcesUpdater,
} from 'components/organisms/document-editor/extensions/custom-section/types';

export const usePeoplePageDerivedSectionSourcesSidePaneState = (): {
  sectionSourceUpdaterProps: PeoplePageDerivedSectionSourcesUpdaterProps | null;
  sectionSourceUpdater: PeoplePageDerivedSectionSourcesUpdater;
  closeSectionSourcesSidePane: VoidFunction;
} => {
  const [sectionSourceUpdaterProps, setSectionSourceUpdaterProps] =
    useState<PeoplePageDerivedSectionSourcesUpdaterProps | null>(null);
  const sectionSourcesUpdaterPropsRef =
    useRef<PeoplePageDerivedSectionSourcesUpdaterProps | null>(null);
  const sectionSourceUpdater: PeoplePageDerivedSectionSourcesUpdater =
    useCallback((props) => {
      if (sectionSourcesUpdaterPropsRef.current != null) {
        sectionSourcesUpdaterPropsRef.current.onCancel();
      }
      setSectionSourceUpdaterProps(props);
      sectionSourcesUpdaterPropsRef.current = props;

      return () => {
        setSectionSourceUpdaterProps(null);
        sectionSourcesUpdaterPropsRef.current = null;
      };
    }, []);
  const closeSectionSourcesSidePane = useCallback(() => {
    sectionSourceUpdaterProps?.onCancel();
    setSectionSourceUpdaterProps(null);
    sectionSourcesUpdaterPropsRef.current = null;
  }, [sectionSourceUpdaterProps]);

  return {
    sectionSourceUpdaterProps,
    sectionSourceUpdater,
    closeSectionSourcesSidePane,
  };
};
